document.addEventListener("DOMContentLoaded", function() {
  const section = document.querySelector(".homepage-collections");
  if (!section) return;

  const items = section.querySelectorAll(".collection-grid__item");
  items.forEach(item => {
    const width = item.offsetWidth;
    item.style.height = width + "px"; // Force square
  });

  // Recalculate on window resize
  window.addEventListener("resize", () => {
    items.forEach(item => {
      const width = item.offsetWidth;
      item.style.height = width + "px";
    });
  });
});
